export default `#ifdef GL_ES
precision highp float;
#endif

uniform sampler2D tDiffuse;
uniform sampler2D tDepth;
uniform vec2 resolution;
uniform float edlStrength;
uniform float edlRadius;
uniform float cameraNear;
uniform float cameraFar;

float logLinDepth(vec2 uv, out bool valid) {
  float raw = texture2D(tDepth, uv).r;
  valid = raw < 0.9999;
  float d = raw * 2.0 - 1.0;
  float lin = 2.0 * cameraNear * cameraFar / (cameraFar + cameraNear - d * (cameraFar - cameraNear));
  return log2(max(1e-4, lin));
}

void main() {
  vec2 uv = gl_FragCoord.xy / resolution;

  bool selfValid;
  float d = logLinDepth(uv, selfValid);

  
  if (!selfValid) {
    gl_FragColor = texture2D(tDiffuse, uv);
    return;
  }

  vec2 px = edlRadius / resolution;

  float resp = 0.0;
  bool nValid;
  float nd;

  
  nd = logLinDepth(uv + vec2( px.x, 0.0), nValid); if (nValid) resp += max(0.0, d - nd);
  nd = logLinDepth(uv + vec2(-px.x, 0.0), nValid); if (nValid) resp += max(0.0, d - nd);
  nd = logLinDepth(uv + vec2(0.0,  px.y), nValid); if (nValid) resp += max(0.0, d - nd);
  nd = logLinDepth(uv + vec2(0.0, -px.y), nValid); if (nValid) resp += max(0.0, d - nd);

  
  
  float shade = exp(-resp * 300.0 * edlStrength);

  vec4 color = texture2D(tDiffuse, uv);
  gl_FragColor = vec4(color.rgb * shade, color.a);
}`